import LegalLayout, { H2, H3, P, UL } from "./LegalLayout";

/**
 * CGV PitBoard V1.2 — Juin 2026
 * Source : Document officiel MJSA INVEST validé.
 * NB : Toute modification substantielle nécessite un bump de LEGAL_VERSION
 * dans /app/backend/legal_version.py pour forcer la re-validation des utilisateurs.
 */
export default function CGV() {
  return (
    <LegalLayout title="Conditions Générales de Vente & Mentions Légales" lastUpdated="Juin 2026 — Version 1.2">
      <P>
        Conforme LCEN · RGPD · Loi SREN · Data Act · Réforme e-facturation 2026-2027
      </P>
      <P>
        <b>Éditeur :</b> MJSA INVEST<br/>
        <b>Forme juridique :</b> Société à responsabilité limitée (SARL) – Société à associé unique – Holding<br/>
        <b>Produit :</b> PitBoard – Logiciel SaaS de gestion pour entrepreneurs<br/>
        <b>SIREN :</b> 831 701 867<br/>
        <b>RCS :</b> 831 701 867 R.C.S. Reims<br/>
        <b>Capital social :</b> 446 862,00 €<br/>
        <b>TVA intracommunautaire :</b> FR27831701867<br/>
        <b>Gérant / Directeur de publication :</b> Julien PINOT<br/>
        <b>Date d&apos;entrée en vigueur :</b> 1<sup>er</sup> juillet 2026<br/>
        <b>Droit applicable :</b> Droit français<br/>
        <b>Juridiction :</b> Tribunal de Commerce de Reims
      </P>
      <P>
        <b>⚠️ Ce document a valeur contractuelle. Toute souscription à PitBoard implique
        l&apos;acceptation pleine et entière des présentes conditions.</b>
      </P>

      <H2>PARTIE I — MENTIONS LÉGALES</H2>

      <H3>Article 1 – Éditeur du site et du logiciel</H3>
      <P>
        Conformément aux dispositions de l&apos;article 6-III de la loi n°2004-575 du 21 juin 2004
        pour la Confiance dans l&apos;Économie Numérique (LCEN), telle que modifiée par la loi
        n°2024-449 du 21 mai 2024 (loi SREN), les présentes mentions légales sont portées à la
        connaissance des utilisateurs du logiciel PitBoard et du site associé.
      </P>
      <P>
        <b>Société éditrice :</b> MJSA INVEST<br/>
        <b>Forme juridique :</b> Société à responsabilité limitée (SARL) – Société à associé unique – Holding<br/>
        <b>Siège social :</b> 13 Rue Denis Papin, 51100 Reims<br/>
        <b>Numéro SIREN :</b> 831 701 867<br/>
        <b>Numéro RCS :</b> 831 701 867 R.C.S. Reims<br/>
        <b>Capital social :</b> 446 862,00 €<br/>
        <b>Numéro de TVA intracommunautaire :</b> FR27831701867<br/>
        <b>Directeur de la publication :</b> Julien PINOT<br/>
        <b>Contact :</b> <a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>
      </P>

      <H3>Article 2 – Hébergement et sous-traitants</H3>
      <P>
        L&apos;infrastructure applicative (frontend, backend API) et la base de données du logiciel
        PitBoard sont hébergées par :<br/>
        <b>Sous-traitant technique :</b> Emergent Labs Inc. (opérateur de la plateforme d&apos;hébergement)<br/>
        <b>Base de données :</b> MongoDB Atlas (opéré par MongoDB Inc.)<br/>
        <b>Localisation :</b> centres de données situés dans l&apos;Union Européenne
      </P>
      <P>
        Les emails transactionnels (magic link, notifications, factures) sont envoyés via
        <b> Resend.com</b> (sous-traitant, serveurs UE). Les paiements sont opérés par
        <b> Stripe Payments Europe Ltd</b> (aucune donnée bancaire n&apos;est stockée sur nos serveurs).
      </P>
      <P>
        MJSA INVEST veille à ce que les données Client soient localisées prioritairement au sein de
        l&apos;Union Européenne, conformément aux exigences du RGPD et aux recommandations de la CNIL.
        En cas de changement de sous-traitant ou de localisation, le Client en sera informé au moins
        trente (30) jours avant la mise en œuvre effective.
      </P>
      <P>
        <b>Sauvegardes :</b> les données Client font l&apos;objet de sauvegardes automatiques
        journalières par le sous-traitant d&apos;hébergement. Néanmoins, aucune sauvegarde tierce
        ne remplace un export local régulier réalisé par le Client (voir Article 11.4).
      </P>

      <H3>Article 3 – Propriété intellectuelle</H3>
      <P>
        L&apos;ensemble des éléments constituant le logiciel PitBoard (code source, interfaces,
        bases de données, algorithmes, marques, logos, documentation) est la propriété
        exclusive de MJSA INVEST et est protégé par les dispositions du Code de la propriété
        intellectuelle, notamment les articles L.111-1 et suivants relatifs au droit d&apos;auteur
        et les articles L.341-1 et suivants relatifs aux bases de données.
      </P>
      <P>
        Toute reproduction, représentation, modification, publication ou adaptation, totale
        ou partielle, de ces éléments, quel que soit le moyen ou le procédé utilisé, est
        interdite sans l&apos;autorisation écrite préalable de MJSA INVEST, sous peine de
        poursuites judiciaires.
      </P>

      <H3>Article 4 – Données personnelles et RGPD</H3>
      <P>
        MJSA INVEST traite des données à caractère personnel dans le cadre de l&apos;exploitation
        du logiciel PitBoard, en qualité de responsable de traitement au sens du Règlement
        (UE) 2016/679 du 27 avril 2016 (RGPD). Les traitements mis en œuvre sont détaillés
        dans la Politique de Confidentialité accessible depuis l&apos;application.
      </P>
      <P>
        Conformément aux articles 15 à 22 du RGPD, tout utilisateur dispose d&apos;un droit
        d&apos;accès, de rectification, d&apos;effacement, de limitation, de portabilité et
        d&apos;opposition concernant ses données personnelles. Ces droits peuvent être exercés
        en adressant une demande écrite à : <a href="mailto:dpo@pitboard-app.fr" className="underline">dpo@pitboard-app.fr</a>
        {" "}ou par courrier au siège social de MJSA INVEST — 13 Rue Denis Papin, 51100 Reims.
      </P>
      <P>
        En cas de réclamation non résolue, l&apos;utilisateur peut saisir la Commission
        Nationale de l&apos;Informatique et des Libertés (CNIL) :
        {" "}<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="underline">www.cnil.fr</a>
        {" "}– 3 Place de Fontenoy, 75007 Paris.
      </P>

      <H3>Article 5 – Cookies</H3>
      <P>
        Le logiciel PitBoard utilise des cookies et traceurs nécessaires à son fonctionnement
        technique, ainsi que des cookies analytiques soumis au consentement préalable de
        l&apos;utilisateur, conformément aux recommandations de la CNIL et à l&apos;article 82
        de la loi Informatique et Libertés. L&apos;utilisateur peut gérer ses préférences via
        le panneau de gestion des cookies accessible dans l&apos;application.
      </P>

      <H3>Article 6 – Médiation et règlement des litiges</H3>
      <P>
        Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, MJSA INVEST
        propose un dispositif de médiation de la consommation. L&apos;entité de médiation
        retenue est : le Médiateur du Tribunal de Commerce de Reims (55-57 rue Thiers,
        CS 80034, 51724 Reims Cedex), dont les coordonnées sont disponibles sur demande à
        {" "}<a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>.
      </P>
      <P>
        La plateforme européenne de règlement en ligne des litiges est accessible à :
        {" "}<a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="underline">https://ec.europa.eu/consumers/odr</a>
      </P>

      <H2>PARTIE II — CONDITIONS GÉNÉRALES DE VENTE (CGV)</H2>

      <H3>Article 1 – Objet et champ d&apos;application</H3>
      <P>
        Les présentes Conditions Générales de Vente (ci-après « <b>CGV</b> ») régissent les
        relations contractuelles entre MJSA INVEST, société éditrice du logiciel PitBoard
        (ci-après « <b>l&apos;Éditeur</b> »), et toute personne physique ou morale exerçant une
        activité professionnelle (ci-après « <b>le Client</b> ») souscrivant un abonnement au
        logiciel PitBoard.
      </P>
      <P>
        PitBoard est un logiciel de gestion en mode SaaS (Software as a Service) destiné aux
        entrepreneurs français, comprenant les fonctionnalités suivantes : établissement de
        devis et de factures conformes à la réglementation en vigueur (notamment la réforme
        de la facturation électronique 2026-2027), suivi du chiffre d&apos;affaires et des
        dépenses, projection de trésorerie.
      </P>
      <P>
        Les présentes CGV s&apos;appliquent à l&apos;exclusion de toutes autres conditions,
        notamment celles du Client. Elles prévalent sur tout document émanant du Client.
        Toute souscription à PitBoard emporte acceptation pleine et entière des présentes CGV.
      </P>

      <H3>Article 2 – Définitions</H3>
      <UL>
        <li><b>« Logiciel / Service »</b> : Le logiciel PitBoard accessible en mode SaaS via internet.</li>
        <li><b>« Éditeur »</b> : MJSA INVEST, société éditrice et exploitante du logiciel PitBoard.</li>
        <li><b>« Client »</b> : Toute personne physique ou morale professionnelle ayant souscrit un abonnement.</li>
        <li><b>« Utilisateur »</b> : Toute personne physique autorisée par le Client à accéder au Service.</li>
        <li><b>« Abonnement »</b> : Contrat à durée indéterminée à renouvellement mensuel donnant accès au Service.</li>
        <li><b>« Données Client »</b> : L&apos;ensemble des données saisies, importées ou générées par le Client dans le Service.</li>
        <li><b>« DPA »</b> : Data Processing Agreement – accord de traitement des données conclu entre l&apos;Éditeur et le Client.</li>
      </UL>

      <H3>Article 3 – Accès au Service et création de compte</H3>
      <P>
        L&apos;accès au Service est conditionné à la création d&apos;un compte utilisateur sur la
        plateforme PitBoard. Le Client s&apos;engage à fournir des informations exactes,
        complètes et à jour lors de son inscription. Toute fausse déclaration engage la
        responsabilité exclusive du Client.
      </P>
      <P>
        Le Client est seul responsable de la confidentialité de ses identifiants de
        connexion. Toute utilisation du Service avec les identifiants du Client est présumée
        effectuée par le Client lui-même. En cas de perte ou de compromission des
        identifiants, le Client doit en informer immédiatement l&apos;Éditeur à
        {" "}<a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>.
      </P>
      <P>
        L&apos;Éditeur se réserve le droit de suspendre ou de résilier tout compte dont les
        informations s&apos;avéreraient inexactes ou dont l&apos;utilisation serait contraire aux
        présentes CGV.
      </P>

      <H3>Article 4 – Abonnement et durée</H3>
      <P>
        L&apos;abonnement à PitBoard est souscrit pour une durée indéterminée, avec une période
        minimale d&apos;engagement d&apos;un (1) mois. Il est renouvelé automatiquement chaque
        mois à la date anniversaire de la souscription, sauf résiliation dans les conditions
        prévues à l&apos;article 10.
      </P>
      <P>
        Une période d&apos;essai gratuite peut être proposée au Client lors de la première
        souscription. Les modalités de cette période d&apos;essai (durée, fonctionnalités
        accessibles) sont précisées sur la page de tarification de PitBoard. À l&apos;issue de
        la période d&apos;essai, l&apos;abonnement payant est activé automatiquement, sauf
        résiliation préalable par le Client.
      </P>

      <H3>Article 5 – Tarifs et modalités de paiement</H3>
      <P>
        Les tarifs applicables sont ceux en vigueur au moment de la souscription, tels
        qu&apos;affichés sur la page de tarification de PitBoard. Tous les prix sont indiqués
        en euros (€) hors taxes (HT) et toutes taxes comprises (TTC), la TVA applicable
        étant celle en vigueur au jour de la facturation.
      </P>
      <P>
        <b>Modalités de paiement :</b> Le paiement est effectué par prélèvement automatique
        mensuel via la plateforme sécurisée Stripe (Stripe, Inc. / Stripe Payments Europe,
        Ltd.). En souscrivant à PitBoard, le Client autorise MJSA INVEST à débiter son moyen
        de paiement enregistré du montant de l&apos;abonnement à chaque échéance mensuelle.
      </P>
      <P>
        <b>Sécurité des paiements :</b> Les transactions sont sécurisées par le protocole TLS
        et sont conformes aux exigences de la Directive européenne sur les services de
        paiement (DSP2 – Directive 2015/2366/UE), notamment en matière d&apos;authentification
        forte du client (SCA – Strong Customer Authentication).
      </P>
      <P>
        <b>Défaut de paiement :</b> En cas d&apos;échec de prélèvement, l&apos;Éditeur en informera
        le Client par email. Sans régularisation dans un délai de sept (7) jours calendaires,
        l&apos;Éditeur se réserve le droit de suspendre l&apos;accès au Service. Passé un délai de
        trente (30) jours sans régularisation, l&apos;abonnement pourra être résilié de plein droit.
      </P>
      <P>
        <b>Modification tarifaire :</b> L&apos;Éditeur se réserve le droit de modifier ses tarifs.
        Toute modification sera notifiée au Client par email au moins trente (30) jours avant
        son entrée en vigueur. Le Client qui n&apos;accepte pas la nouvelle tarification peut
        résilier son abonnement sans frais avant la date d&apos;entrée en vigueur.
      </P>

      <H3>Article 6 – Conformité à la réforme de la facturation électronique (2026-2027)</H3>
      <P>
        PitBoard intègre les fonctionnalités nécessaires à la conformité des utilisateurs
        avec la réforme française de la facturation électronique, mise en œuvre
        progressivement à compter du 1<sup>er</sup> septembre 2026 conformément à
        l&apos;ordonnance n°2021-1190 du 15 septembre 2021 et aux textes d&apos;application associés.
      </P>
      <P><b>Calendrier de conformité intégré à PitBoard :</b></P>
      <UL>
        <li><b>Dès le 1<sup>er</sup> septembre 2026 :</b> Réception des factures électroniques pour l&apos;ensemble des entreprises assujetties à la TVA. PitBoard permet la réception et le traitement des factures électroniques dans les formats réglementaires (Factur-X, UBL, CII).</li>
        <li><b>À compter du 1<sup>er</sup> septembre 2027 :</b> Obligation d&apos;émission de factures électroniques pour les PME et micro-entreprises. PitBoard assurera l&apos;émission de factures conformes via une Plateforme de Dématérialisation Partenaire (PDP) agréée ou via le Portail Public de Facturation (PPF).</li>
      </UL>
      <P>
        L&apos;Éditeur s&apos;engage à mettre à jour le Service afin de maintenir sa conformité
        avec l&apos;évolution de la réglementation. Ces mises à jour sont incluses dans
        l&apos;abonnement sans surcoût.
      </P>
      <P>
        <b>Responsabilité du Client :</b> Il appartient au Client de vérifier que
        l&apos;utilisation de PitBoard est adaptée à sa situation fiscale spécifique et de
        consulter son expert-comptable pour toute question relative à ses obligations
        déclaratives.
      </P>

      <H3>Article 7 – Obligations de l&apos;Éditeur</H3>
      <P>
        <b>7.1 Disponibilité du Service :</b> L&apos;Éditeur s&apos;engage à mettre tout en œuvre
        pour assurer la disponibilité du Service 24h/24 et 7j/7, avec un objectif de
        disponibilité de 99,5% par mois civil, hors maintenances planifiées. Les
        maintenances programmées sont notifiées au Client au moins 48 heures à l&apos;avance.
      </P>
      <P>
        <b>7.2 Sécurité et confidentialité :</b> L&apos;Éditeur met en œuvre les mesures
        techniques et organisationnelles appropriées pour garantir la sécurité, l&apos;intégrité
        et la confidentialité des Données Client, conformément à l&apos;article 32 du RGPD.
        Des sauvegardes régulières des données sont effectuées.
      </P>
      <P>
        <b>7.3 Mises à jour :</b> L&apos;Éditeur assure la maintenance corrective et évolutive
        du Service, incluant les mises à jour réglementaires nécessaires (notamment en
        matière de facturation électronique et de conformité fiscale).
      </P>
      <P>
        <b>7.4 Support :</b> L&apos;Éditeur met à disposition du Client un support technique
        accessible par email à <a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>,
        du lundi au vendredi, de 9h à 18h (heure de Paris), hors jours fériés.
      </P>

      <H3>Article 8 – Obligations du Client</H3>
      <P>
        Le Client s&apos;engage à utiliser le Service conformément à sa destination et aux
        présentes CGV. Il s&apos;interdit notamment de :
      </P>
      <UL>
        <li>Utiliser le Service à des fins illicites ou contraires à l&apos;ordre public ;</li>
        <li>Tenter d&apos;accéder sans autorisation aux systèmes informatiques de l&apos;Éditeur ;</li>
        <li>Introduire des virus, chevaux de Troie ou tout autre code malveillant ;</li>
        <li>Revendre, sous-licencier ou transférer son accès au Service à des tiers ;</li>
        <li>Procéder à de l&apos;ingénierie inverse ou à la décompilation du logiciel ;</li>
        <li>Utiliser le Service d&apos;une manière susceptible de porter atteinte aux droits de tiers.</li>
      </UL>
      <P>
        Le Client est seul responsable des données qu&apos;il saisit dans le Service et
        garantit qu&apos;elles ne portent pas atteinte aux droits de tiers. Il s&apos;engage à
        maintenir ses informations de compte à jour.
      </P>

      <H3>Article 9 – Données personnelles et DPA</H3>
      <P>
        Dans le cadre de l&apos;exécution des présentes CGV, MJSA INVEST agit en qualité de
        sous-traitant au sens de l&apos;article 28 du RGPD pour les données personnelles que le
        Client traite via PitBoard. Le Client agit en qualité de responsable de traitement.
        Un Accord de Traitement des Données (DPA) est annexé aux présentes CGV et en fait
        partie intégrante. Il définit notamment : la nature et la finalité des traitements,
        les catégories de données traitées, les obligations respectives des parties, les
        mesures de sécurité mises en œuvre et les conditions de recours à des sous-traitants
        ultérieurs.
      </P>
      <P>
        <b>Portabilité et réversibilité des données (Data Act &amp; Loi SREN) :</b> Conformément
        au Règlement (UE) 2023/2854 (Data Act, applicable depuis le 12 septembre 2025) et à
        la loi SREN n°2024-449 du 21 mai 2024, le Client bénéficie d&apos;un droit à la
        portabilité de ses données. À tout moment, et notamment en cas de résiliation, le
        Client peut exporter l&apos;intégralité de ses Données Client dans un format ouvert et
        interopérable (CSV, JSON ou équivalent), sans frais.
      </P>

      <H3>Article 10 – Résiliation</H3>
      <P>
        <b>10.1 Résiliation par le Client :</b> Le Client peut résilier son abonnement à tout
        moment, sans motif ni pénalité, depuis son espace personnel ou en adressant une
        demande à <a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>.
        La résiliation prend effet à la fin de la période mensuelle en cours. Aucun
        remboursement prorata temporis n&apos;est effectué pour la période restante du mois en cours.
      </P>
      <P>
        <b>10.2 Résiliation par l&apos;Éditeur :</b> L&apos;Éditeur peut résilier l&apos;abonnement en
        cas de manquement grave du Client à ses obligations contractuelles, non remédié dans
        un délai de quinze (15) jours suivant mise en demeure par email. En cas de
        manquement grave et immédiat (fraude, atteinte à la sécurité du Service), la
        résiliation peut être immédiate.
      </P>
      <P>
        <b>10.3 Effets de la résiliation :</b> À la date d&apos;effet de la résiliation,
        l&apos;accès du Client au Service est désactivé. Le Client dispose d&apos;un délai de
        trente (30) jours pour exporter ses Données Client. Passé ce délai, les données sont
        supprimées de manière sécurisée, sauf obligation légale de conservation.
      </P>

      <H3>Article 11 – Responsabilité et garanties</H3>
      <P>
        <b>11.1 Limitation de responsabilité :</b> La responsabilité de l&apos;Éditeur est
        limitée aux dommages directs et prévisibles. En aucun cas l&apos;Éditeur ne pourra être
        tenu responsable des dommages indirects, immatériels, pertes de données, manque à
        gagner ou préjudice commercial subi par le Client. Le montant total de la
        responsabilité de l&apos;Éditeur est plafonné au montant des sommes effectivement
        versées par le Client au cours des douze (12) derniers mois précédant le fait générateur.
      </P>
      <P>
        <b>11.2 Force majeure :</b> L&apos;Éditeur ne pourra être tenu responsable de tout
        manquement à ses obligations résultant d&apos;un cas de force majeure au sens de
        l&apos;article 1218 du Code civil (catastrophe naturelle, cyberattaque d&apos;ampleur,
        défaillance des infrastructures internet, etc.).
      </P>
      <P>
        <b>11.3 Exactitude des données :</b> PitBoard est un outil d&apos;aide à la gestion.
        L&apos;Éditeur ne garantit pas l&apos;exactitude des projections de trésorerie ou des
        analyses financières générées, qui dépendent des données saisies par le Client. Ces
        informations ne constituent pas un conseil financier ou comptable.
        {" "}<b>Les bibliothèques d&apos;ouvrages, prix, temps et matériaux pré-remplis (« Packs Métiers »)
        sont fournis à titre purement indicatif et informatif</b> ; ils ne constituent en
        aucun cas un engagement contractuel sur les marges, la rentabilité, les coûts réels
        ou les durées d&apos;exécution. Le Client demeure seul responsable de l&apos;adaptation
        des prix, des temps et des matériaux à son contexte, sa zone géographique, sa
        clientèle et ses contraintes de marché.
      </P>
      <P>
        <b>11.4 Continuité et sauvegarde — obligation d&apos;export régulier du Client :</b>{" "}
        Bien que l&apos;Éditeur mette en œuvre des sauvegardes automatiques journalières
        (voir Article 2), aucune infrastructure n&apos;est infaillible (incidents matériels
        majeurs, cyberattaque, faillite d&apos;un sous-traitant, résiliation du contrat, etc.).
        En conséquence, <b>il incombe au Client de télécharger et de conserver en local
        une copie complète de ses Données Client au minimum une fois tous les trente (30) jours</b>{" "}
        via la fonctionnalité « Exporter mes données » disponible depuis son profil (menu
        Profil entreprise). Un rappel automatique par email est envoyé au Client tous les
        30 jours pour l&apos;y inviter.
      </P>
      <P>
        <b>11.5 Limitation en cas de perte de données :</b> En cas de perte, corruption ou
        indisponibilité totale des données Client résultant d&apos;un incident affectant
        l&apos;infrastructure de l&apos;Éditeur ou de ses sous-traitants, l&apos;Éditeur mettra
        en œuvre tous les moyens raisonnables pour restaurer les données à partir des
        sauvegardes disponibles. Toutefois, si le Client n&apos;a pas effectué d&apos;export
        local dans les 30 jours précédant l&apos;incident conformément à l&apos;article 11.4,
        <b> aucune indemnisation ne pourra être réclamée à l&apos;Éditeur au-delà du
        plafond fixé à l&apos;article 11.1</b>, la charge de la preuve de la perte incombant
        au Client. Il appartient au Client de mesurer l&apos;importance de ses données et
        d&apos;organiser sa propre politique de sauvegarde en conséquence.
      </P>

      <H3>Article 12 – Propriété intellectuelle</H3>
      <P>
        L&apos;Éditeur concède au Client, à titre personnel, non exclusif, non cessible et non
        transférable, un droit d&apos;utilisation du Service pour la durée de l&apos;abonnement
        et aux seules fins prévues par les présentes CGV. Ce droit d&apos;utilisation ne
        constitue en aucun cas une cession de droits de propriété intellectuelle.
      </P>
      <P>
        Le Client conserve l&apos;entière propriété de ses Données Client. En souscrivant à
        PitBoard, le Client concède à l&apos;Éditeur une licence non exclusive et gratuite
        d&apos;utilisation de ses données aux seules fins d&apos;exécution du Service
        (hébergement, traitement, affichage, sauvegarde).
      </P>

      <H3>Article 13 – Confidentialité</H3>
      <P>
        Chaque partie s&apos;engage à maintenir strictement confidentielles toutes les
        informations de nature confidentielle communiquées par l&apos;autre partie dans le
        cadre de l&apos;exécution des présentes CGV, et à ne pas les divulguer à des tiers sans
        l&apos;accord préalable écrit de l&apos;autre partie. Cette obligation de confidentialité
        survit à la résiliation du contrat pour une durée de cinq (5) ans.
      </P>

      <H3>Article 14 – Modification des CGV</H3>
      <P>
        L&apos;Éditeur se réserve le droit de modifier les présentes CGV à tout moment. Toute
        modification substantielle sera notifiée au Client par email au moins trente (30)
        jours avant son entrée en vigueur. Le Client qui n&apos;accepte pas les nouvelles CGV
        peut résilier son abonnement sans frais avant la date d&apos;entrée en vigueur. À
        défaut de résiliation, le Client est réputé avoir accepté les nouvelles CGV.
      </P>

      <H3>Article 15 – Droit applicable et juridiction compétente</H3>
      <P>
        Les présentes CGV sont soumises au droit français. En cas de litige relatif à la
        formation, l&apos;interprétation ou l&apos;exécution des présentes CGV, les parties
        s&apos;engagent à rechercher une solution amiable dans un délai de trente (30) jours.
        À défaut d&apos;accord amiable, tout litige sera soumis à la compétence exclusive du
        Tribunal de Commerce de Reims, sauf disposition légale impérative contraire.
      </P>
      <P>
        <b>Médiation :</b> Conformément aux articles L.612-1 et suivants du Code de la
        consommation, le Client professionnel peut recourir au Médiateur du Tribunal de
        Commerce de Reims (55-57 rue Thiers, CS 80034, 51724 Reims Cedex). Les coordonnées
        du médiateur sont disponibles sur demande à
        {" "}<a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>.
      </P>

      <H3>Article 16 – Dispositions diverses</H3>
      <P>
        <b>Intégralité de l&apos;accord :</b> Les présentes CGV, ainsi que leurs annexes (DPA,
        Politique de Confidentialité), constituent l&apos;intégralité de l&apos;accord entre les
        parties et remplacent tout accord antérieur relatif à leur objet.
      </P>
      <P>
        <b>Divisibilité :</b> Si une clause des présentes CGV est déclarée nulle ou
        inapplicable par une juridiction compétente, les autres clauses demeurent en vigueur.
      </P>
      <P>
        <b>Non-renonciation :</b> Le fait pour l&apos;Éditeur de ne pas se prévaloir d&apos;un
        manquement du Client à l&apos;une quelconque des obligations des présentes CGV ne
        saurait être interprété comme une renonciation à se prévaloir de ce manquement à l&apos;avenir.
      </P>
      <P>
        <b>Cession :</b> Le Client ne peut céder tout ou partie de ses droits et obligations
        au titre des présentes CGV sans l&apos;accord préalable écrit de l&apos;Éditeur.
        L&apos;Éditeur peut librement céder les présentes CGV dans le cadre d&apos;une opération
        de fusion, acquisition ou cession d&apos;actifs.
      </P>

      <P style={{ marginTop: "2rem", fontSize: "0.85rem", color: "var(--grey)" }}>
        Document établi par MJSA INVEST — PitBoard v1.2 — Juin 2026<br/>
        SIREN 831 701 867 — RCS Reims — Capital 446 862,00 € — TVA FR27831701867 —
        {" "}<a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>
      </P>
    </LegalLayout>
  );
}
